// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 0 16px;
}

.update-icon {
  font-size: 72px;
  color: var(--ion-color-light);
  margin-bottom: 24px;
}

h2 {
  font-weight: bold;
  font-size: 22px;
  margin: 0;
}

p {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 32px;
  color: var(--ion-color-medium);
}

.update-btn {
  margin-bottom: 40px;
}

  `, "",{"version":3,"sources":["webpack://./src/app/shared/modals/version-checker/version-checker.component.ts"],"names":[],"mappings":";EACE;EACA,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["\n  .container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n  padding: 0 16px;\n}\n\n.update-icon {\n  font-size: 72px;\n  color: var(--ion-color-light);\n  margin-bottom: 24px;\n}\n\nh2 {\n  font-weight: bold;\n  font-size: 22px;\n  margin: 0;\n}\n\np {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 32px;\n  color: var(--ion-color-medium);\n}\n\n.update-btn {\n  margin-bottom: 40px;\n}\n\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
